import { AxiosRequestHeaders } from 'axios';

import { LocalStorageKey } from 'shared/types';
import { localStorage } from 'shared/utils';

export const getRequestHeaders = (
  headers: AxiosRequestHeaders = {},
): AxiosRequestHeaders => {
  const token = localStorage.getItem(LocalStorageKey.TOKEN);

  return token ? { ...headers, Authorization: token } : headers;
};
